import instantsearch from 'instantsearch.js';
import getRouting from './routing';
import getSearchClient from '../proxiedSearchClient';
import { analytics, pagination, stats } from 'instantsearch.js/es/widgets';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import { googlePlacesWidget } from './widgets/googlePlaces';

import {
  area,
  clearRefinements,
  configure,
  currentRefinements,
  opportunities,
  radius,
  refinementList,
  searchBox,
  presenceMenu,
  durationKindMenu,
} from './widgets';

const insightsMiddleware = createInsightsMiddleware({
  insightsClient: window.aa,
});

export const OpportunitySearch = ({ url, csrfToken, indexName, appId, apiKey }, attributes) => ({
  init() {
    const ais = instantsearch({
      searchClient: getSearchClient({ url, csrfToken, appId, apiKey }),
      indexName,
      routing: getRouting({ indexName }),
    });

    ais.use(insightsMiddleware);

    const widgets = [
      configure({ clickAnalytics: true }),
      searchBox({ container: this.$refs.searchBox }),
      durationKindMenu({ container: this.$refs.durationKind }),
      presenceMenu({ container: this.$refs.presence }),
      opportunities({
        container: this.$refs.hits,
        // cache: instantsearch.createInfiniteHitsSessionStorageCache(),
        paginationSentinel: this.$refs.pagination,
        cache: instantsearch.createInfiniteHitsSessionStorageCache(),
      }),
      googlePlacesWidget({ container: this.$refs.area }),
      currentRefinements({ container: this.$refs.currentRefinements }),
      clearRefinements({ container: this.$refs.clearRefinements }),
      radius({ container: this.$refs.radius }),
      refinementList({
        title: 'Issue area',
        container: this.$refs.issueArea,
        attribute: 'concentrated_cause_areas',
      }),
      refinementList({
        title: 'Skills/Interests',
        container: this.$refs.skills,
        attribute: 'concentrated_skills',
      }),
      refinementList({
        title: 'Features',
        container: this.$refs.features,
        attribute: 'concentrated_features',
      }),

      stats({
        container: this.$refs.stats,
        templates: {
          text: `
              {{#hasNoResults}}No results, Please add a Location or Keyword for best results.{{/hasNoResults}}
              {{#hasOneResult}}1 result{{/hasOneResult}}
              {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results{{/hasManyResults}}
            `,
        },
      }),

      analytics({
        pushFunction(formattedParameters, state, results) {
          window.dataLayer.push({
            event: 'algoliaUiInteraction',
          });
        },
        triggerOnUIInteraction: true,
      }),
    ];

    ais.addWidgets(widgets).start();
  },

  ...attributes,
});
